export type TriggerType = 'processCrash' | 'console';
/**

 */
/**
 * @description 彩蛋触发逻辑
 *
 * 使用方式:
 *
 *   <div @click="eggClick">点击n次触发彩蛋</div>
 *
 *  import { useEggHandler } from '@/renderer/scripts/composition/useEggHandler';
 *
 *  const { eggClick } = useEggHandler();
 * @param times 点击次数，默认5
 * @param trigger 自定义触发 也可自定义Function
 *
 */
export const useEggHandler = (times = 5, trigger: Function | TriggerType) => {
  let clickTimes = 0;
  let clickTimer = 0;
  // 内置的一部分彩蛋
  const doEggActions = (e: MouseEvent): void => {
    // 用户按住了 三个按键
    const commandEnter = (e.ctrlKey || e.metaKey) && e.shiftKey;
    if (commandEnter) {
      if (trigger === 'processCrash') {
        process.crash();
      } else if (typeof trigger === 'function') {
        trigger(e);
      }
    }
    // 没有按到 就不触发彩蛋
  };
  // 彩蛋
  const eggClick = (e: MouseEvent) => {
    clickTimes++;
    if (clickTimes >= times) {
      clickTimes = 0;
      doEggActions(e);
    }
    clickTimer && window.clearTimeout(clickTimer);
    clickTimer = window.setTimeout(() => {
      clickTimes = 0;
    }, 500);
  };
  return {
    eggClick,
  };
};
